module.exports = __webpack_public_path__ + "static/img/4.933df34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxopen/4.png
// module id = 1iMo
// module chunks = 1